export default __webpack_public_path__ + "static/media/24.4f8643aa.mp3";